import { captureIPAddress } from './analyticsService';

/**
 * Simple utility to test the IP capture functionality
 */
export const testIPCapture = async () => {
  console.log('🧪 Testing IP capture functionality...');
  
  try {
    // Create a fake order ID for testing
    const testOrderId = 'test-' + Date.now();
    
    // Try to capture IP
    console.log('📡 Attempting to capture IP address...');
    const result = await captureIPAddress(testOrderId);
    
    console.log('✅ IP capture result:', result);
    
    return {
      success: true,
      ip: result.ip,
      message: 'IP address captured successfully!'
    };
  } catch (error) {
    console.error('❌ IP capture test failed:', error);
    
    return {
      success: false,
      error: error.message
    };
  }
};